window.addEventListener("load", () => {
  const favBtns = document.querySelectorAll(".lc__favourites");

  const ca_app = {
    url: "https://customer-accounts.jjtpaulir9rbk.eu-west-2.cs.amazonlightsail.com",
    method: "post",
    createConfig: function (type, data) {
      let formData = new FormData();
      let keys = Object.keys(data);
      keys.forEach((key) => {
        formData.append(key, data[key]);
      });

      return {
        method: this.method,
        url: `${this.url}/favourites/${type}`,
        data: formData,
        timeout: 0,
        processData: false,
        mimeType: "multipart/form-data",
        contentType: false,
      };
    },
    timeoutId: null,
    displayTimeout: {
      hide: (elem) => {
        ca_app.timeoutId = setTimeout(() => {
          elem.style.display = "none";
        }, 1000);
      },
      interrupt: () => {
        clearTimeout(ca_app.timeoutId);
      },
    },
    addFavourite: async function (favBtn, preConfigObj) {
      $.ajax(this.createConfig("add", preConfigObj)).done((response) => {
        console.log('here is the response: ', response)
      });

      favBtn.classList.remove("add");
      favBtn.classList.add("remove", "anim");
      this.displayTimeout.hide(favBtn.querySelector(".fav-anim"));
    },
    removeFavourite: function (favBtn, preConfigObj) {
      $.ajax(this.createConfig("remove", preConfigObj)).done((response) => {
        console.log('here is the response: ', response)
      });
      this.displayTimeout.interrupt();
      favBtn.classList.remove("remove", "anim");
      favBtn.classList.add("add");
      favBtn.querySelector(".fav-anim").style.display = "block";
    },
  };

  const handleFavourite = (e) => {
    let isAdd;
    let r = e.currentTarget;
    r.classList.contains("add") ? (isAdd = true) : (isAdd = false);
    let preConfig = {
      customer_id: r.querySelector('input[name="fav-prop-customer-id"]').value,
      product_id: r.querySelector('input[name="fav-prop-product-id"]').value,
      product_url: r.querySelector('input[name="fav-prop-product-url"]').value,
      product_img: r.querySelector('input[name="fav-prop-product-img"]').value,
      product_price: r.querySelector('input[name="fav-prop-product-price"]')
        .value,
      product_title: r.querySelector('input[name="fav-prop-product-title"]')
        .value,
    };

    console.log(
      `${isAdd ? "item added to favourites" : "item removed from favourites"}`
    );
    isAdd
      ? ca_app.addFavourite(r, preConfig)
      : ca_app.removeFavourite(r, preConfig);
  };

  favBtns.forEach((favBtn) => {
    favBtn.addEventListener("click", handleFavourite);
  });
});
